import { z } from 'zod'
import { MonetaryValueSchema } from '@shared/lib/money/money'

const amount = MonetaryValueSchema.shape.amount.refine(value => !value.startsWith('-'))
const earnings = z.object({
  gross: amount,
  reversed: amount,
  net: amount,
  pending: amount,
  currency: z.literal('BRL'),
})
export const ReferralSummarySchema = z.object({
  earnings,
  balance: z.object({ currency: z.literal('BRL'), available: amount, pending: amount, reserve: amount, processing: amount }),
})
export const ReferralProgramSchema = z.object({
  enabled: z.boolean(),
  percentage: z.string().regex(/^\d{1,3}(\.\d{1,3})?$/).refine(value => Number(value) > 0 && Number(value) <= 100),
  inviteUrl: z.string().url().nullable(),
  totals: earnings,
  total: z.number().int().nonnegative(),
  nextOffset: z.number().int().nonnegative().nullable(),
  items: z.array(z.object({ id: z.string(), name: z.string(), joinedAt: z.string(), earnings })),
})
export type ReferralProgram = z.infer<typeof ReferralProgramSchema>
